import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"
import type { CreatePromoCodeRequest, CreatePromoCodeResponse } from "../types"

export function useCreatePromoCode() {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreatePromoCodeRequest) => {
      const response = await apiFetch<CreatePromoCodeResponse>("/admin/promo-codes", {
        token,
        method: "POST",
        body: JSON.stringify(data),
      })
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["promoCodes"] })
    },
  })
}
